import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import * as e from "react";
const s = (o, t) => /* @__PURE__ */ r.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: t, ...o, children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M12.28 4.22a.75.75 0 0 1 0 1.06L7.56 10l4.72 4.72a.75.75 0 0 1-1.06 1.06l-5.25-5.25a.75.75 0 0 1 0-1.06l5.25-5.25a.75.75 0 0 1 1.06 0Z" }) }), l = e.forwardRef(s);
export {
  l as F
};
//# sourceMappingURL=ChevronLeft20.CgL7KAAg.js.map
